import { getTailwindColor } from '@/utils/tailwindColors'

const values: string[] = [
    getTailwindColor('red', '300'),
    getTailwindColor('green', '300'),
    getTailwindColor('blue', '300'),
    getTailwindColor('orange', '300'),
    getTailwindColor('purple', '300'),
    getTailwindColor('pink', '300'),
    getTailwindColor('red', '600'),
    getTailwindColor('green', '600'),
    getTailwindColor('blue', '600'),
    getTailwindColor('orange', '600'),
    getTailwindColor('purple', '600'),
    getTailwindColor('pink', '600'),
    getTailwindColor('yellow', '600'),
    getTailwindColor('red', '800'),
    getTailwindColor('green', '800'),
    getTailwindColor('blue', '800'),
    getTailwindColor('orange', '800'),
    getTailwindColor('purple', '800'),
    getTailwindColor('pink', '800'),
    getTailwindColor('yellow', '800'),
    getTailwindColor('neutral', '800'),
    getTailwindColor('black'),
]

export const getStrokeHexValue = (index: number): string =>
    values[index % values.length]
